import React from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useBlocks } from "@jelly/lesson";

import styles from "./Slide4.module.scss";
import { useUi } from "@jelly/lesson";

interface Slide4 {
  title: string;
  description: string;
  videoUrl: string;
  videoCaption: string;
}

export const Slide4: React.FC<Slide4> = ({ title, description, videoUrl, videoCaption }) => {
  const block = useBlocks();
  const ui = useUi();

  const leftComponent = (
    <ui.Scrollbars>
      <div className={styles.leftComponent}>
        <p>{description}</p>
      </div>
    </ui.Scrollbars>
  );

  return (
    <div className={styles.root}>
      <StandardCase title={title} leftComponent={leftComponent}>
        <div className={styles.rightComponent}>
          <div className={styles.videoBlock}>
            <block.video src={videoUrl} provider="youtube" />
          </div>
          <p className={styles.caption}>{videoCaption}</p>
        </div>
      </StandardCase>
    </div>
  );
};
